module.exports = __webpack_public_path__ + "static/media/piscines_cosgaya_white.a96362d8.png";